import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { HelperService, HTTPService, ValidationService } from 'app/services';

@Component({
  selector: 'send-template-view',
  templateUrl: './send-template-view.component.html',
  styleUrls: ['./send-template-view.component.scss'],
  providers: [DialogService],
})
export class SendPreviewTemplate implements OnInit {
  errors: any = {};
  template: any;
  isLoading = false;
  isSending: boolean = false;

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    private validationService: ValidationService
  ) {}

  ngOnInit() {
    this.template = this.dialogConfig.data.template;
  }
  validate(): boolean {
    let isValid: boolean = true;

    this.errors = {};

    if (this.template.email && !this.validationService.validateEmail(this.template.email)) {
      this.errors.email = 'Email is not valid';
      isValid = false;
    }
    return isValid;
  }
  closeDialog(isSuccess: boolean = false, data: any = {}) {
    this.dialogRef.close({ isSuccess, data });
  }

  handleChange(type, e: any): void {
    this.errors[type] = '';
    this.template[type] = e;
  }

  sendPreviewEmail(): void {
    if (!this.validate() || this.isLoading) return;

    this.isSending = true;

    const template = { ...this.template };
    this.httpService
      .sendPreviewEmail({
        email: this.template.email,
        template,
      })
      .then(() => {
        this.isSending = false;
        this.helperService.showToaster('success', 'Sent successfully');
        this.closeDialog();
      })
      .catch((err) => this.helperService.showToaster('error', err))
      .finally(() => {
        this.isSending = false;
      });
  }
}
